import PrimaryButton from "../designSystem/buttons/PrimaryButton";
import PrimaryButtonSmall from "../designSystem/buttons/PrimaryButtonSmall";
import SecondaryButton from "../designSystem/buttons/SecondaryButton";
import SecondaryButtonSmall from "../designSystem/buttons/SecondaryButtonSmall";
import TextButton from "../designSystem/buttons/TextButton";
import SeeMoreButton from "../designSystem/buttons/SeeMoreButton";
import Hero from "../designSystem/Hero";
import SEO from "../designSystem/SEO";
import TertiaryButton from "../designSystem/buttons/TertiaryButton";
import Accordion from "../designSystem/Accordion";
import AboutUs1 from "../../assets/images/aboutus_meetashley.png";
import AboutUs2 from "../../assets/images/aboutus_whatwedo.png";
import AboutUs3 from "../../assets/images/aboutus_whychooseak.png";
import AboutUs4 from "../../assets/images/aboutus_ourapproach.png";
import { useNavigate } from "react-router-dom";
import FirstTimeBuyersGuide from "../../assets/files/first_time_buyers_guide.pdf";
import BuyToLetGuide from "../../assets/files/buy_to_let_guide.pdf";
import TaxGuide from "../../assets/files/tax_guide.pdf";
import { ReactComponent as One } from "../../assets/icons/1.svg";
import { ReactComponent as Two } from "../../assets/icons/2.svg";
import { ReactComponent as Three } from "../../assets/icons/3.svg";
import { ReactComponent as Four } from "../../assets/icons/4.svg";
import { ReactComponent as Five } from "../../assets/icons/5.svg";
import { ReactComponent as Six } from "../../assets/icons/6.svg";
import { ReactComponent as Seven } from "../../assets/icons/7.svg";
import { ReactComponent as Eight } from "../../assets/icons/8.svg";
import { ReactComponent as CheckIcon } from "../../assets/icons/checkmark.svg";

const WhoWeArePage = () => {
  const navigate = useNavigate();
  return (
    <div>
      <SEO
        title="Who We Are"
        description="Meet Ashley Knight and learn about AK Mortgages' friendly, honest and ethical approach to mortgage and protection advice."
        path="/about-us/who-we-are"
      />
      <Hero
        title={`Friendly. Honest. Ethical Mortgage & Protection Advice`}
        subtitle="About us"
        titleAlign="center"
        subtitleAlign="center"
      >
        <div className="column-center gap-s">
          <div className="content text-primary-1">
            At AK Mortgages, we believe mortgage advice should be clear, simple
            and easy to understand. We focus on giving honest guidance without
            jargon or pressure, so you always feel confident in your decisions.
            Whether you are buying your first home, moving house, remortgaging
            or investing in property, we are here to help you every step of the
            way.
          </div>
          <div className="content text-primary-1">
            Based in Bristol, we work with clients across the UK and provide
            straightforward advice that is tailored to your needs.
          </div>
        </div>
      </Hero>
      <div className="background-container bg-white">
        <div className="content-container row gap-xxxxxl">
          <img src={AboutUs1} alt="Ashley Knight, founder of AK Mortgages" className="hero-image" />
          <div className="column gap-l">
            <div className="subtitle-semibold  text-primary-2 uppercase">
              About Us
            </div>
            <h2 className="text-primary-1 uppercase">Meet ashley Knight</h2>
            <div className="column gap-m">
              <div className="column gap-s">
                <div className="content text-primary-1">
                  I am Ashley Knight, founder of AK Mortgages and a Mortgage &
                  Protection Adviser. I started AK Mortgages to offer a more
                  honest and personal approach to mortgage advice. I believe the
                  process should feel simple and supportive, not confusing or
                  rushed.
                </div>
                <div className="content text-primary-1">
                  I take the time to understand your situation, explain your
                  options clearly and help you find the right solution for your
                  circumstances. Whether you are buying your first home,
                  remortgaging or looking at protection for your family, I will
                  guide you through the process from start to finish.
                </div>
              </div>
              <div className="row-wrap gap-xxxl">
                <div className="row-center gap-m">
                  <CheckIcon />
                  <div className="content-semibold text-primary-1 uppercase">
                    Friendly
                  </div>
                </div>
                <div className="row-center gap-m">
                  <CheckIcon />
                  <div className="content-semibold text-primary-1 uppercase">
                    honest
                  </div>
                </div>
                <div className="row-center gap-m">
                  <CheckIcon />
                  <div className="content-semibold text-primary-1 uppercase">
                    ethical
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="background-container bg-primary-1">
        <div className="content-container row gap-xxxxxl">
          <img src={AboutUs2} alt="Mortgage and protection advice services" className="hero-image" />
          <div className="column gap-l">
            <div className="subtitle-semibold  text-primary-2 uppercase">
              what we do
            </div>
            <h3 className="text-white uppercase">
              We help clients with a range of mortgage and protection needs
            </h3>
            <div className="column gap-m">
              <div className="content text-white">
                <ul className="content text-white column gap-m">
                  <li>First-time buyer mortgages</li>
                  <li>Home mover mortgages</li>
                  <li>Remortgaging</li>
                  <li>Buy-to-let mortgages</li>
                  <li>Life insurance</li>
                  <li>Critical illness cover</li>
                  <li>Home buyer protection</li>
                  <li>Income protection</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="background-container">
        <div className="content-container row-reverse gap-xxxxxl">
          <div className="column gap-l">
            <div className="column gap-s">
              <h3 className="text-primary-1 uppercase">
                Why Choose AK Mortgages?
              </h3>
            </div>
            <div className="column gap-m">
              <div className="content text-primary-1">
                We focus on giving advice that is right for you, rather than
                taking a one-size-fits-all approach. When you work with us, you
                can expect clear and honest advice, with no jargon or pressure,
                along with personal recommendations tailored to your individual
                situation. We support you every step of the way, from
                application through to completion, and provide access to a wide
                range of lenders and products, all delivered with a friendly and
                approachable service. We believe good advice starts with
                listening.
              </div>
            </div>
          </div>
          <img src={AboutUs3} alt="AK Mortgages client advice meeting" className="hero-image" />
        </div>
      </div>
      <div className="background-container bg-gray-3">
        <div className="content-container row gap-xxxxxl">
          <img src={AboutUs4} alt="AK Mortgages advice approach" className="hero-image" />
          <div className="column gap-l">
            <div className="subtitle-semibold  text-primary-2 uppercase">
              our approach
            </div>
            <h3 className="text-primary-1 uppercase">
              We take time to understand:
            </h3>
            <div className="column gap-m">
              <div className="column gap-l">
                <div className="row-center gap-l">
                  <One />
                  <div className="content-semibold text-primary-1 uppercase">
                    your SITUATION
                  </div>
                </div>
                <div className="row-center gap-l">
                  <Two />
                  <div className="content-semibold text-primary-1 uppercase">
                    your income and budget
                  </div>
                </div>
                <div className="row-center gap-l">
                  <Three />
                  <div className="content-semibold text-primary-1 uppercase">
                    Your FINANCIAL
                  </div>
                </div>
                <div className="row-center gap-l">
                  <Four />
                  <div className="content-semibold text-primary-1 uppercase">
                    commitments
                  </div>
                </div>
                <div className="row-center gap-l">
                  <Five />
                  <div className="content-semibold text-primary-1 uppercase">
                    Your PLANS FOR THE FUTURE
                  </div>
                </div>
                <div className="row-center gap-l">
                  <Six />
                  <div className="content-semibold text-primary-1 uppercase">
                    Your protection needs
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="background-container bg-gray-1">
        <div className="content-container column gap-l">
          <div className="column gap-m">
            <div className="subtitle-semibold  text-white uppercase">
              Let’s get started
            </div>
            <div className="column gap-s">
              <div className="content text-white">
                Whether you are buying your first home, reviewing your mortgage
                or looking for advice on protection, we are here to help.
              </div>
              <div className="content text-white">
                We offer free, no-obligation consultations so you can talk
                through your options with no pressure.
              </div>
            </div>
            <PrimaryButton
              text="book a free initial appointment"
              onClick={() =>
                window.open(
                  "https://bookings.cloud.microsoft/bookwithme/user/fa2261725ab84f21bb747357792d358b%40akmortgages.uk?anonymous&ismsaljsauthenabled",
                  "_blank",
                )
              }
            />
          </div>
          <div className="body2 text-white">
            Protection plans are subject to terms and conditions. The
            availability and cost of cover depend on individual circumstances.
            Your home may be repossessed if you do not keep up with repayments
            on your mortgage.
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhoWeArePage;
